import { Order } from 'Types/generic';

export const getNextSortDirection = (currentSortDirection?: Order): Order => {
	const isSortDirectionSet = currentSortDirection !== undefined;
	const isSortDirectionDescending = currentSortDirection === Order.Descending;

	return isSortDirectionSet && isSortDirectionDescending ? Order.Ascending : Order.Descending;
};
